import { gql } from "../../../../../gql/__generated__/gql";

export const GET_ALL_PRODUCTS_FOR_BRAND = gql(`
  query getAllProductsForBrand($brandId: String!) {
    getAllProductsForBrand(brandId: $brandId) {
      id
      brandId
      name
      productUrl
      imageUrl
      description
      price
      categories
      createdAt
      updatedAt
    }
  }
`);
